module.exports = __webpack_public_path__ + "static/media/recetas.c48e59a8.jpg";